import "../_commonjsHelpers-b0e8727a.js";
import "react";
import "../index-f450c016.js";
export { C as default } from "../countryflag-ecc0d7d1.js";